<template>
    <ui-modal :title="`${form.title}`" :name="name" icon="far fa-calendar-times" size="xs" :above-all="true" :load="load">
        <section class="modal-content-line">
            <form>
                <div class="input-group">
                    <label class="label" for="reason">Você pode informar o motivo do cancelamento:</label>
                    <textarea id="reason" v-model="form.data.reason" />
                </div>
            </form>

            <div class="action-nugget">
                <ui-nugget-actions-sage-status
                    v-model="action"
                    :action-type="actionType"
                    title="Mover para:"
                    design="grid-2"
                    nugget-id="cancel-modal"
                />
            </div>
        </section>

        <template #footer>
            <ui-button :disabled="!canSubmit" type="button" design="md success" @click="submit">Confirmar</ui-button>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiButton } from '@/components/ui/buttons'
    import { uiNuggetActionsSageStatus } from '@/components/ui-facilita/nuggets'

    import { reserve } from '@/services/axios'

    import { mapGetters } from 'vuex'

    const defaultForm = () => ({
        title: 'Cancelar Reserva',
        data: {
            id: null,
            expire_time: '00:00:00',
            reason: '',
            status: 'canceled'
        }
    })

    export default {
        name: 'ui-reservations-cancel-modal',

        components: {
            uiNuggetActionsSageStatus,
            uiModal,
            uiButton,
        },

        props: {
            name: {
                type: String,
                require: true,
                default: ''
            }
        },

        data() {
            return {
                form: { ...defaultForm() },
                action: {},
                type: 'cancel',
                eventSuccess: '',
                load: false
            }
        },

        computed: {
            ...mapGetters('auth', {
                user: 'getUser'
            }),
            /**
             * Computed property que define se o formulário poder ser salvo
             */
			canSubmit() {
				return this.form.data.id && this.action?.no_action
                    ? true
                    : this.action.action_id
			},
            actionType(){
                return this.type == 'cancel' ? 'cancel_reserve' : 'distract_sale'
            }
        },

        mounted() {
            this.$root.$on('modal-open-' + this.name, (data) => {
                this.reset()

                this.type = data.type
                this.$root.$emit('clean--nugget-actions-stage-status-form-cancel-modal')
                this.$root.$emit('nugget-actions-stage-status-form-cancel-modal')

                /** Verifica se existem configurações para o modal */
                if (data.config) this.$set(this.form, 'title', data.config.title)
                if (data.deal && data.deal.id_reserve) {
                    this.$set(this.form.data, 'id', data.deal.id_reserve)
                }

                this.eventSuccess = data.config.eventSuccess
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-' + this.name)
            this.$root.$off('nugget-actions-stage-status-form-cancel-modal')
            this.$root.$off('clean--nugget-actions-stage-status-form-cancel-modal')
        },

        methods: {
            /**
             * Reseta o estado do formulário para a próxima edição
             */
            reset() {
                this.form = { ...defaultForm() }
                this.action = {}
            },
            /**
             * Submita o formulário de modo a salvar as alterações no negócio
             */
            submit() {
                if (!this.canSubmit) return
                this.load = true
                reserve.updateV2('', this.form.data.id, {...this.form.data, action_id: this.action.action_id})
                    .then(response => {
                        if (response.data.msg) this.$toastr.s(response.data.msg)

                        this.$root.$emit('modal-close-' + this.name)
                        this.$root.$emit(this.eventSuccess)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    }).finally(() => {
                        this.load = false
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>